import { FETCH_CATEGORIES } from "../actions/WordPressApiAction";
const initialCategoriesReducer = [
  {
    id: 0,
    name: "",
    child: [],
    count: 0,
  },
];

export default function fetchCategoriesReducer(
  state = initialCategoriesReducer,
  action
) {
  switch (action.type) {
    case FETCH_CATEGORIES:
      return action.categories;
    default:
      return state;
  }
}
